



















import Vue from 'vue';

export default Vue.extend({
  name: 'NumbersDropdown',
  data() {
    return {
      showSelects: false,
      valueSelected: '',
    };
  },

  props: {
    initialValue: {
      type: String,
      default: '',
    },
    numbers: {
      type: Array,
      default: () => [],
    },
    labelBold: {
      type: String,
      default: 'labelBold',
    },
    labelNormal: {
      type: String,
      default: 'labelNormal',
    },
  },
  methods: {
    toggleShow: function() {
      this.showSelects = !this.showSelects;
    },
    itemClicked: function(item: string) {
      this.toggleShow();
      this.changeValue(item);
      this.$emit('option-selected', item);
    },
    changeValue: function(value: string) {
      this.valueSelected = value;
    },
  },
});
